import instance from 'api';
import { ICalendarCountry, ICalendarDay, IDayStatus, IWorkType } from './interfaces';

export const getCalendarDays = (year: number, workTypeId: number, countryId?: number, cityId?: number | null) => {
  return instance()
    .post<ICalendarDay[]>('/calendar/list', { year, workTypeId, countryId, cityId })
    .then((response) => response.data);
};

export const addDayToCalendar = (day: ICalendarDay) => {
  return instance()
    .post('/calendar/save', day)
    .then((response) => response.data);
};

export const updateCalendarDay = (day: ICalendarDay) => {
  return instance()
    .post('/calendar/update', day)
    .then((response) => response.data);
};

export const deleteDayFromCalendar = (day: ICalendarDay) => {
  return instance()
    .post('/calendar/delete', day)
    .then((response) => response.data);
};

export const createStatus = (value: any) => {
  return instance()
    .post<IDayStatus>('/calendarSchedule/save', value)
    .then((response) => response.data);
};

export const updateStatus = (value: any) => {
  return instance()
    .post<IDayStatus>('/calendarSchedule/update', value)
    .then((response) => response.data);
};

export const loadStatus = (calendarScheduleId: number) => {
  return instance()
    .post<IDayStatus>('/calendarSchedule/load', { calendarScheduleId })
    .then((response) => response.data);
};

export const loadStatusListShort = (workTypeId: number) => {
  return instance()
    .post<IDayStatus[]>('/calendarSchedule/listShort', { workTypeId })
    .then((response) => response.data);
};

// dictionaries
export const getCalendarCountries = () => {
  return instance()
    .get<ICalendarCountry[]>('/calendar/countries')
    .then((response) => response.data);
};

export const getWorkTypes = () => {
  return instance()
    .post<IWorkType[]>('/dictionary/workTypes/list')
    .then((response) => response.data);
};
